<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
body {
  background-color: #2f353a;
  color: #e4e7ea;
}
.highcharts-axis-title {
  color: white !important;
  fill: white !important;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #23282c;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #23282c;
}

.table tbody + tbody {
  border-top: 2px solid #23282c;
}

.table .table {
  background-color: #2f353a;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #23282c;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #23282c;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #c1e7f4;
}

.table-hover .table-primary:hover {
  background-color: #abdff0;
}

.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #abdff0;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d8dce0;
}

.table-hover .table-secondary:hover {
  background-color: #cacfd5;
}

.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #cacfd5;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #cdedd8;
}

.table-hover .table-success:hover {
  background-color: #bae6c9;
}

.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #bae6c9;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #d3eef6;
}

.table-hover .table-info:hover {
  background-color: #bee6f2;
}

.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #bee6f2;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffeeba;
}

.table-hover .table-warning:hover {
  background-color: #ffe8a1;
}

.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #ffe8a1;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #fdd6d6;
}

.table-hover .table-danger:hover {
  background-color: #fcbebe;
}

.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #fcbebe;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fcfcfc;
}

.table-hover .table-light:hover {
  background-color: #efefef;
}

.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #efefef;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c5c6c8;
}

.table-hover .table-dark:hover {
  background-color: #b8b9bc;
}

.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b8b9bc;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #2f353a;
  background-color: #23282c;
  border-color: #343b41;
}

.table .thead-light th {
  color: #e4e7ea;
  background-color: #343b41;
  border-color: #23282c;
}
.sk-double-bounce {
  width: 40px;
  height: 40px;
  position: relative;
  margin: 40px auto;
}

.sk-double-bounce .sk-child {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #e4e7ea;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: sk-doubleBounce 2s infinite ease-in-out;
  animation: sk-doubleBounce 2s infinite ease-in-out;
}
@-webkit-keyframes sk-doubleBounce {
  0%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.toast-body {
  color: black;
}
.toast-header {
  color: black;
}
@keyframes sk-doubleBounce {
  0%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.sk-double-bounce .sk-double-bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}
.input-group-text {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #e4e7ea;
  text-align: center;
  white-space: nowrap;
  background-color: #343b41;
  border: 1px solid #23282c;
  border-radius: 0.25rem;
}
.form-control {
  display: block;
  width: 100%;
  height: calc(2.0625rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #e4e7ea;
  background-color: #515b65;
  background-clip: padding-box;
  border: 1px solid #23282c;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control:focus {
  color: #e4e7ea;
  background-color: #515b65;
  border-color: #8ad4ee;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #fff;
}
.table-dark {
  color: #2f353a;
  background-color: #23282c;
}

.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #343b41;
}

.table-dark.table-bordered {
  border: 0;
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}

.table-dark.table-hover tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.075);
}
.sidebar {
  background: #3a4149;
  border-right: 1px solid #23282c;
}
.dropdown-item {
  position: relative;
  padding: 10px 20px;
  border-bottom: 1px solid #23282c !important;
  display: block;
  width: 100%;
  clear: both;
  font-weight: 400;
  color: #e4e7ea;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
}
.modal-header {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #23282c;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
.form-control {
  display: block;
  width: 100%;
  height: calc(2.0625rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #e4e7ea;
  background-color: #515b65;
  background-clip: padding-box;
  border: 1px solid #23282c;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.modal-content {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #3a4149;
  background-clip: padding-box;
  border: 1px solid #23282c;
  border-radius: 0.3rem;
  outline: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #e4e7ea;
  text-decoration: none;
  background-color: #2f353a;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #e4e7ea;
  text-align: left;
  list-style: none;
  background-color: #3a4149;
  background-clip: padding-box;
  border: 1px solid #23282c;
  border-radius: 0.25rem;
}
.card {
  word-wrap: break-word;
  background-color: #3a4149;
  background-clip: border-box;
  border: 1px solid #23282c;
  border-radius: 0.25rem;
}
.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: #343b41;
  border-top: 1px solid #23282c;
}
.app-header {
  position: relative;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 55px;
  padding: 0;
  margin: 0;
  background-color: #3a4149;
  border-bottom: 1px solid #23282c;
}
.breadcrumb {
  position: relative;
  border-radius: 0;
  border-bottom: 1px solid #23282c;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  list-style: none;
  background-color: #3a4149;
}
.navbar-nav .nav-link {
  color: #c8ced3;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #343b41;
  border-bottom: 1px solid #23282c;
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat 50%;
  background-size: 100% 100%;
}
.app-header .navbar-toggler-icon {
  height: 23px;
  color: #e4e7ea;
}
.brand-card {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  margin-bottom: 1.5rem;
  word-wrap: break-word;
  background-color: #3a4149;
  background-clip: border-box;
  border: 1px solid #23282c;
  border-radius: 0.25rem;
}
.app-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 1rem;
  color: #e4e7ea;
  background: #3a4149;
  border-top: 1px solid #23282c;
}
.navbar-nav .active > .nav-link,
.navbar-nav .active > .nav-link:focus,
.navbar-nav .active > .nav-link:hover,
.navbar-nav .nav-link.active,
.navbar-nav .nav-link.active:focus,
.navbar-nav .nav-link.active:hover,
.navbar-nav .nav-link.open,
.navbar-nav .nav-link.open:focus,
.navbar-nav .nav-link.open:hover,
.navbar-nav .nav-link:focus,
.navbar-nav .nav-link:hover,
.navbar-nav .open > .nav-link,
.navbar-nav .open > .nav-link:focus,
.navbar-nav .open > .nav-link:hover {
  color: #e4e7ea;
}
.progress {
  height: 1rem;
  overflow: hidden;
  font-size: 0.65625rem;
  background-color: #515b65;
  border-radius: 0.25rem;
}
.progress-xs {
  height: 4px;
}
</style>
